import React from 'react';
import './ProjectsGalleryItem.scss';

import dayjs from 'dayjs';
import {dateFormat} from '../../../../helpers/constants';
import {CheckboxMUI, IconButtonMUI} from '../../../../shared';
import {ReactComponent as PlayIcon} from '../../../../assets/icons/playSecond.svg';
import {ReactComponent as TrashIcon} from '../../../../assets/icons/trash.svg';
import {hasPermission} from '../../../../helpers/functions';
import {useTranslation} from 'react-i18next';

const ProjectsGalleryItem = ({
  el,
  checkedItems,
  handleCheck,
  type,
  date,
  creator,
  deleteReportHandler,
  setPopupView,
  permissions,
  permissionTrash,
  permissionDownload
}) => {
  const {t} = useTranslation();

  const partialPermission =
    hasPermission(permissionDownload, permissions) || hasPermission(permissionTrash, permissions);

  return (
    <div className={'projects__gallery-wrapper'}>
      <div className='projects__gallery-date'>{dayjs(date).format(dateFormat)}</div>
      <div className='projects__gallery-from'>{creator.first_name}</div>
      <div className='projects__gallery-list'>
        {type === 'photos' &&
          el.map((item, index) => {
            const checked = checkedItems.includes(item.id);
            return (
              <div key={item.id} className='projects__gallery-item'>
                {hasPermission(permissionTrash, permissions) && (
                  <div
                    className='projects__gallery-remove'
                    onClick={() => {
                      deleteReportHandler(item.id, type);
                    }}
                  >
                    <IconButtonMUI
                      color={'inherit'}
                      title={t('ProjectsReports.common.trash')}
                      disableRipple={true}
                      disableFocusRipple={true}
                    >
                      <TrashIcon />
                    </IconButtonMUI>
                  </div>
                )}

                {partialPermission && (
                  <div className='projects__gallery-checkbox'>
                    <CheckboxMUI
                      checked={checked}
                      onChange={() => {
                        handleCheck(item.id);
                      }}
                    />
                  </div>
                )}

                <img
                  src={item.image.thumbnail}
                  alt={item.id}
                  onClick={() => {
                    setPopupView({
                      files: el,
                      index: index,
                      type: 'photo',
                      visible: true
                    });
                  }}
                />
              </div>
            );
          })}
        {type === 'videos' &&
          el.map((video, index) => {
            const checked = checkedItems.includes(video.id);
            return (
              <div className='projects__gallery-item' key={video.id}>
                {hasPermission(permissionTrash, permissions) && (
                  <div className='projects__gallery-remove' onClick={() => deleteReportHandler(video.id, type)}>
                    <IconButtonMUI color={'inherit'} title={t('ProjectsReports.common.trash')}>
                      <TrashIcon />
                    </IconButtonMUI>
                  </div>
                )}
                {partialPermission && (
                  <div className='projects__gallery-checkbox'>
                    <CheckboxMUI
                      checked={checked}
                      onChange={() => {
                        handleCheck(video.id);
                      }}
                    />
                  </div>
                )}

                <div className='projects__gallery-video'>
                  <video src={video.link} />
                </div>
                <div
                  className={'projects__gallery-play'}
                  onClick={() =>
                    setPopupView({
                      files: el,
                      index: index,
                      type: 'videos',
                      visible: true
                    })
                  }
                >
                  <PlayIcon />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ProjectsGalleryItem;
